import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import EmailIcon from '@mui/icons-material/Email';
import GroupsIcon from '@mui/icons-material/Groups';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import SchoolIcon from '@mui/icons-material/School';
import SportsIcon from '@mui/icons-material/Sports';
import type { SvgIconComponent } from '@mui/icons-material';

export const INTAKE_SECTION_ICONS: Record<string, SvgIconComponent> = {
  person: PersonIcon,
  groups: GroupsIcon,
  chat: ChatBubbleOutlineIcon,
  email: EmailIcon,
  school: SchoolIcon,
  sports: SportsIcon,
  phone: PhoneIcon,
  location: LocationOnIcon,
};

export function getIntakeIcon(name?: string): SvgIconComponent | null {
  if (!name) return null;
  return INTAKE_SECTION_ICONS[name] ?? null;
}
